//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data() {
			return {}
		},
		/*  model: {
		      prop: 'isShow',
		      event: 'change'
		  },*/
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '提示'
			},
			theme:{
				type: String,
			},
			width: {
				type: [Number, String]
			},
			content: {
				default: '是否删除此内容？'
			},
			confirmText: {
				type: String,
				default: '确定'
			},
		},
		watch: {

		},
		methods: {
			_onConfirm() {
				this.$emit('change', false)
			},
		}
	}




// WEBPACK FOOTER //
// ./src/components/alertPlugin/alert.vue